export const parseApiResponse = (rawData, users) => {
	if (!rawData || typeof rawData !== 'object') return [];

	return Object.entries(rawData).map(([userId, dateMap]) => {
		const user = users.find((u) => u._id === userId);
		const username = user?.username || userId;

		const dates = Object.entries(dateMap).map(([date, stats]) => {
			const hours = stats.hours;
			const confirmed = stats.confirmed;
			const delivered = stats.delivered;

			const confirmedPerH = hours
				? Math.round((confirmed / hours) * 10) / 10
				: null;
			const deliveredPerH = hours
				? Math.round((delivered / hours) * 10) / 10
				: null;

			return {
				date,
				confirmedPerH,
				deliveredPerH,
				confirmed,
				delivered,
				hours,
			};
		});

		return { userId, username, dates };
	});
};
